import MobileDetect from 'mobile-detect/mobile-detect.js';

const getWindowDimensions = () => {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
};

export const windowDimensions = element => {
    const windowSizes = getWindowDimensions(element);
    const isVerticalScreen = windowSizes.height > windowSizes.width;
    const isVerticalTablet = Boolean(
        new MobileDetect(window.navigator.userAgent).tablet() && windowSizes.height > windowSizes.width
    );
    return { isVerticalScreen, isVerticalTablet };
};
